import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { palette } from "../../Theme";
import { faExclamationCircle } from "@fortawesome/pro-regular-svg-icons/faExclamationCircle";
import { faExclamationTriangle } from "@fortawesome/pro-regular-svg-icons/faExclamationTriangle";
import { faInfoCircle } from "@fortawesome/pro-regular-svg-icons/faInfoCircle";
import { faCircleCheck } from "@fortawesome/pro-regular-svg-icons/faCircleCheck";
// Theme configuration:
export const MuiAlert = {
    defaultProps: {
        iconMapping: {
            error: _jsx(FontAwesomeIcon, { icon: faExclamationCircle }),
            warning: _jsx(FontAwesomeIcon, { icon: faExclamationTriangle }),
            info: _jsx(FontAwesomeIcon, { icon: faInfoCircle }),
            success: _jsx(FontAwesomeIcon, { icon: faCircleCheck })
        }
    },
    styleOverrides: {
        root: {
            display: "flex",
            padding: "8px 12px",
            alignItems: "center",
            gap: "8px"
        },
        filled: (props) => ({
            color: palette[props.ownerState.severity]["contrastText"],
            borderRadius: 0,
            padding: "8px 24px",
            "& .MuiAlert-action": {
                color: palette[props.ownerState.severity]["contrastText"]
            },
            "& .MuiAlert-message": {
                color: palette[props.ownerState.severity]["contrastText"]
            },
            "& .MuiButton-root": {
                color: palette[props.ownerState.severity]["contrastText"]
            }
        }),
        icon: {
            fontSize: "16px",
            padding: "8px 0",
            marginRight: 0
        },
        message: {
            fontSize: "14px",
            fontWeight: 400,
            padding: "6px 0",
            color: palette.text.primary
        },
        action: {
            padding: 0
        }
    }
};
//# sourceMappingURL=Alert.js.map